import { render, staticRenderFns } from "./MoveNotices.vue?vue&type=template&id=4918a96b&scoped=true&"
import script from "./MoveNotices.vue?vue&type=script&lang=js&"
export * from "./MoveNotices.vue?vue&type=script&lang=js&"
import style0 from "./MoveNotices.vue?vue&type=style&index=0&id=4918a96b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4918a96b",
  null
  
)

export default component.exports